module.exports = __webpack_public_path__ + "static/media/navbar_logo.955ebbbb.jpg";